import React from "react";
import { IconButton, Stack } from "@mui/material";

const SocialContact = ({ links }: any) => {
  return (
    <Stack direction="row" spacing={2}>
      {links?.map((link: any, index: number) => (
        <IconButton
          key={index}
          aria-label={link.name}
          color={link.color}
          href={link.url}
          target="_blank"
          rel="noopener noreferrer"
        >
          {link.icon}
        </IconButton>
      ))}
    </Stack>
  );
};

export default SocialContact;
